module.exports = __webpack_public_path__ + "img/water.44244956.jpg";